function AboutAttributesChemicals() {
  return (
    <div id="section44">
      <h3>Chemicals</h3>
      <p>
        We use the term “Chemicals” to refer to a broad variety of entities, including therapeutics,
        endogenous (e.g. endogenous metabolites) and exogenous chemicals (e.g. environmental factors,
        pesticides).{' '}
      </p>
      <p>
        Therapeutics include small molecules, proteins, enzymes and peptides, antibodies, antibody-drug
        conjugates, genes and oligonucleotides and cells.{' '}
      </p>
      <p>
        Chemicals in DISGENET are represented by an internal identifier, and mapped to several identifiers
        such as ChEMBL and PubChem.{' '}
      </p>
      {/* <p>
              The vocabulary used for chemicals in DISGENET is the
              <a href="https://www.nlm.nih.gov/research/umls/index.html" target="_blank" rel="noreferrer">
                {' '}
                UMLS<sup>®</sup> Metathesaurus<sup>®</sup>.
              </a>{' '}
              Each chemical has a Concept Unique Identifier (CUI) from the Unified Medical Language System
              <sup>®</sup> (UMLS) Metathesaurus<sup>®</sup> (version UMLS 2019AB).
            </p> */}

      <p>
        <strong>Chemicals in DISGENET are annotated with: </strong>
      </p>

      <ul>
        {/* 
              The DISGENET chemical identifier.
              The chemical name, obtained from ChEMBL whenever available, 
              The number of publications with chemical mentions (N. PMIDS)
              The number of publications that support GDAs with chemical mentions (N. PMIDs GDA)
              The number of publications that support VDAs with chemical mentions (N. PMIDs VDA)
              “Chemical Effect”: classification of the effect of a chemical on the disease, provided processing expert-curated resources that provide adverse effec
              t information and indications. By using the “Chemical Effect” attribute, you can select chemicals that are used for the treatment of a disease (therapeutic) 
              or lead to a disease (toxicity). This attribute is available in the GDA and
              */}
        <li className="bullet-item">The DISGENET chemical identifier</li>
        <li className="bullet-item">The chemical name, obtained from ChEMBL whenever available</li>
        <li className="bullet-item">The number of publications with chemical mentions (N. PMIDS)</li>
        <li className="bullet-item">
          The number of publications that support GDAs with chemical mentions (N. PMIDs GDA)
        </li>
        <li className="bullet-item">
          The number of publications that support VDAs with chemical mentions (N. PMIDs VDA)
        </li>
        <li className="bullet-item">
          “Chemical Effect”: classification of the effect of a chemical on the disease, provided processing
          expert-curated resources that provide adverse effect information and indications. By using the
          “Chemical Effect” attribute, you can select chemicals that are used for the treatment of a disease
          (therapeutic) or lead to a disease (toxicity). This attribute is available in the GDA and VDA
          Evidence tables with chemical annotations.
        </li>
        <li className="bullet-item">
          Chemical Type: Small molecule, Protein, Unknown, Antibody, Oligosaccharide, Antibody drug conjugate,
          Oligonucleotide, Enzyme, Gene and Cell. This information is obtained from ChEMBL.
        </li>
      </ul>
    </div>
  );
}
export default AboutAttributesChemicals;
